import dayjs from "dayjs";

// Load supported locales
import "dayjs/locale/nl";
import "dayjs/locale/fr";
import "dayjs/locale/de";
import "dayjs/locale/it";

// Duration formatting
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

// Localized formating (LLL)
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat);

import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
